<template>
  <div>
    <customize-page
      label-position="left"
      ref="page"
      inline
      :loading="loading"
      :data="dataList"
      :columns="columns"
      :pagination="pagination"
    >
      <div slot="footer">
        <el-button style="margin-right: 10px" type="primary" @click="fetch">
          搜索
        </el-button>
      </div>
    </customize-page>

    <el-dialog
      title="编辑"
      width="400px"
      :visible.sync="showDialog"
      :close-on-click-modal="false"
    >
      <el-form
        style="width: 300px; margin: 0 auto"
        ref="form"
        :model="form"
        label-width="100px"
        :rules="rules"
      >
        <el-form-item prop="name" label="名称">
          <el-input v-model="form.name" placeholder="名称"></el-input>
        </el-form-item>
        <el-form-item prop="rateMinutes" label="通知频率">
          <el-input-number
            v-model.number="form.rateMinutes"
            :controls="false"
            :precision="0"
            :min="1"
          />
        </el-form-item>
        <el-form-item prop="smsTemplateCode" label="模板code">
          <el-input
            v-model="form.smsTemplateCode"
            placeholder="模板code"
          ></el-input>
        </el-form-item>
        <el-form-item prop="smsSignature" label="模板签名">
          <el-input
            v-model="form.smsSignature"
            placeholder="模板签名"
          ></el-input>
        </el-form-item>
        <el-form-item prop="notifyPhoneNumbers" label="通知手机号">
          <el-input
            v-model="form.notifyPhoneNumbers"
            placeholder="通知手机号,多个请用英文逗号分割"
          ></el-input>
        </el-form-item>
        <el-form-item prop="number" label="阈值">
          <el-input-number
            style="width: 100%"
            :controls="false"
            :precision="0"
            v-model.number="form.number"
            placeholder="订单数或者时间超过阈值则通知"
          />
        </el-form-item>
        <el-form-item prop="state">
          <el-switch
            v-model="form.state"
            active-text="启用"
            inactive-text="禁用"
            active-value="ENABLE"
            inactive-value="DISABLE"
          >
          </el-switch>
        </el-form-item>
        <el-row type="flex" justify="end">
          <el-button type="primary" @click="submit">提交</el-button>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import Page from "@/mixin/Page";
import CustomizePage from "@/components/customize-page";
import orderNotifyConfigApi from "@/api/orderNotifyConfigApi";

export default {
  components: {
    CustomizePage
  },
  mixins: [Page],
  created() {
    this.fetch();
  },
  data() {
    return {
      loading: false,
      showDialog: false,
      form: {
        number: undefined
      },
      dataList: [],
      rules: {
        name: [{ required: true, message: "名称不能为空", trigger: "blur" }],
        rateMinutes: [
          { required: true, message: "通知频率不能为空", trigger: "blur" }
        ],
        smsTemplateCode: [
          { required: true, message: "模板code不能为空", trigger: "blur" }
        ],
        smsSignature: [
          { required: true, message: "模板签名不能为空", trigger: "blur" }
        ],
        notifyPhoneNumbers: [
          { required: true, message: "通知手机号不能为空", trigger: "blur" }
        ],
        number: [{ required: true, message: "阈值不能为空", trigger: "blur" }]
      },
      columns: [
        { title: "名称", key: "name", align: "center" },
        {
          title: "通知频率(分钟/次)",
          key: "rateMinutes",
          align: "center"
        },
        {
          title: "模板code",
          key: "smsTemplateCode",
          align: "center"
        },
        { title: "模板签名", key: "smsSignature", align: "center" },
        {
          title: "通知手机号",
          key: "notifyPhoneNumbers",
          align: "center"
        },
        {
          title: "上次通知成功时间",
          key: "lastSuccessTime",
          align: "center"
        },
        {
          title: "下次通知时间",
          key: "nextNotifyTime",
          align: "center"
        },
        {
          title: "状态",
          key: "state",
          align: "center",
          width: 100,
          render(h, { row }) {
            const tagType = row.state === "ENABLE" ? "success" : "info";
            const tagText = row.state === "ENABLE" ? "启用" : "禁用";
            return (
              <el-tag size="mini" type={tagType}>
                {tagText}
              </el-tag>
            );
          }
        },
        {
          title: "阈值",
          align: "center",
          width: 100,
          render: (h, param) => {
            let data = param.row;
            const json = JSON.parse(data.extJson);
            return <div>{json.number}</div>;
          }
        },
        {
          title: "操作",
          align: "center",
          width: 100,
          render: (h, param) => {
            let data = param.row;
            return (
              <div>
                <el-button
                  type="text"
                  size="mini"
                  on-click={() => this.show(JSON.parse(JSON.stringify(data)))}
                >
                  编辑
                </el-button>
              </div>
            );
          }
        }
      ]
    };
  },
  methods: {
    show(row) {
      this.showDialog = true;
      this.form = row;
      const json = JSON.parse(row.extJson);
      this.form.number = json.number;
    },
    hide() {
      this.showDialog = false;
    },
    submit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          orderNotifyConfigApi
            .update({
              request: {
                id: this.form.id,
                name: this.form.name,
                state: this.form.state,
                rateMinutes: this.form.rateMinutes,
                smsTemplateCode: this.form.smsTemplateCode,
                smsSignature: this.form.smsSignature,
                notifyPhoneNumbers: this.form.notifyPhoneNumbers,
                extJson: JSON.stringify({
                  number: this.form.number
                })
              }
            })
            .then(res => {
              if (res.value) {
                this.$message.success("修改成功");
                this.hide();
                this.fetch();
              }
            });
        }
      });
    },
    fetch() {
      this.loading = true;
      orderNotifyConfigApi
        .getAll()
        .then(res => {
          this.dataList = res.value;
          this.pagination.totalCount = this.dataList.length;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scope>
.inline-p {
  display: inline-block;
  span {
    color: red;
  }
}
</style>
